import { render, staticRenderFns } from "./lzDicTxt.vue?vue&type=template&id=8d98b0ee&"
import script from "./lzDicTxt.vue?vue&type=script&lang=js&"
export * from "./lzDicTxt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports